<div class="padding">
  <!-- Search Bar -->
  <div class="flex-container">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>{{ 'common.labels.searchLiveReports' | transloco }}</mat-label>
      <input
        matInput
        (keyup)="filterReports($event)"
        [placeholder]="'common.labels.typeToSearch' | transloco"
        />
    </mat-form-field>
  </div>

  <div class="flex-container flex-wrap">
    @for (report of filteredReports; track report) {
      <div class="document-card" [@fadeIn]>
        <mat-card class="mat-elevation-z5">
          <!-- Thumbnail Image -->
          <mat-icon class="icon-display margin-top-bottom-25 margin-sides-25">summarize</mat-icon>
          <!-- Card Content -->
          <mat-card-content class="padding">
            <mat-card-title class="card-title">{{ report.name }}</mat-card-title>
            <mat-card-subtitle>{{ report.description }}</mat-card-subtitle>
          </mat-card-content>
          <!-- Card Actions -->
          <mat-card-actions class="card-actions">
            <span class="spacer"></span>
            <button mat-raised-button color="primary" class="prominent-button" [routerLink]="['reportTemplates',report.id]">
              {{ 'common.labels.request' | transloco }}
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
    }
  </div>
</div>